































import { Component, Prop, Vue } from 'vue-property-decorator';

import AnalyticsCard, {
  AnalyticsCardProps,
  AnalyticsCardvariant,
  AnalyticsCardInsightVariant
} from '@/componentsV2/molecules/AnalyticsCard/AnalyticsCard.vue';

export type AnalyticsCardListItem = {
  hidden?: boolean;
  variant?: AnalyticsCardvariant;
  insightVariant?: AnalyticsCardInsightVariant;
  infos: AnalyticsCardProps;
  reportType?: string[];
  components?: {
    [key: string]: {
      as: string;
      [key: string]: any;
    };
  };
};

@Component({
  components: {
    AnalyticsCard
  }
})
export default class AnalyticsCardList extends Vue {
  @Prop({ default: () => [] }) list!: AnalyticsCardListItem[];
  @Prop({ default: 4 }) columns?: number;
  @Prop(String) instanceId!: string;

  observer: IntersectionObserver | null = null;
  triggerIntersected = false;

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get containerStyle() {
    return {
      [`--columns`]: this.columns
    };
  }

  mounted() {
    if (!this.isMobileDevice || !this.instanceId) return;

    const containerId = `#${this.instanceId}`;
    const triggerClass = '.analytics-card-list__trigger';

    const target = document.querySelector(`${containerId} ${triggerClass}`);

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.triggerIntersected = entry.isIntersecting;
      },
      {
        root: document.querySelector(containerId),
        threshold: 0
      }
    );

    this.observer.observe(target as HTMLElement);
  }

  beforeDestroy() {
    if (this.observer) this.observer.disconnect();
  }
}
